export default __webpack_public_path__ + "static/media/google-play.5c01310c.svg";